import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Table,
  Button,
  Modal,
  Image,
  Dropdown,
  Nav,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  FaWallet,
  FaClock,
  FaUsers,
  FaSearch,
  FaCalendar,
  FaCheck,
  FaEdit,
  FaTrash,
  FaCog,
} from "react-icons/fa";
import DatePicker from "react-datepicker";
import { ToastContainer, toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import "../css/CreditDashboard.css";
import { jwtDecode } from "jwt-decode";
import { accountService } from '../services/accountService';
import { creditService } from '../services/creditService';
import { userService } from '../services/userService';
import { formatDateForAPI } from '../utils/dateUtils';
import { Accordion } from "react-bootstrap";
import creditManagementIcon from "../assets/images/icons/credit-red-management-icon.png";
import searchIcon from "../assets/images/icons/search.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { CiCalendar } from "react-icons/ci";
import { FcClearFilters } from "react-icons/fc";
import { RiDeleteBin5Line } from "react-icons/ri";
import { GrEdit } from "react-icons/gr";
import { FaEllipsisV } from "react-icons/fa";
import companyLogo from "../assets/images/brands/re-logo.png";
import customDomainIcon from "../assets/images/icons/custom-domain-icon.png";
import { useNavigate } from "react-router-dom";
import companyImage from "../assets/images/icons/CompanyIcon.png";
import creditsTwoIcon from "../assets/images/icons/creditsTwoIcon.png";
import disable from "../assets/images/disable.png";
import CompanySidebar from "../components/CompanySidebar";


const CreditDashboard = ({ embedded = false, selectedCompanyId: selectedCompanyIdProp = null }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState(() => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return date;
  });
  const [endDate, setEndDate] = useState(new Date());
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [newUserData, setNewUserData] = useState({
    companyId: "",
    availableCredits: "",
  });
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // Check if dates differ from defaults (1 month ago → today)
  const areDatesModified = () => {
    const now = new Date();
    const defaultStart = new Date();
    defaultStart.setMonth(defaultStart.getMonth() - 1);
    const startChanged = startDate && formatDateForAPI(startDate) !== formatDateForAPI(defaultStart);
    const endChanged = endDate && formatDateForAPI(endDate) !== formatDateForAPI(now);
    return startChanged || endChanged;
  };
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 5;
  const [records, setRecords] = useState([]);
  const [user, setUser] = useState([]);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(() => localStorage.getItem("token") || "");
  const [companies, setCompanies] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [creditToDelete, setCreditToDelete] = useState(null);
  const [userRole, setUserRole] = useState("");
  const [creditToEdit, setCreditToEdit] = useState(null);
  const [editFormData, setEditFormData] = useState({
    id: "",
    companyId: "",
    newCredit: "",
    isCreditActive: true,
    transactionType: "CREDIT",
  });
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState(selectedCompanyIdProp);
  const [companyCredits, setCompanyCredits] = useState([]);
  const [userSub, setUserSub] = useState("");
  const [creditHistory, setCreditHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyPage, setHistoryPage] = useState(0);
  const [historySize, setHistorySize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [companySearchTerm, setCompanySearchTerm] = useState("");
  const [creditSummary, setCreditSummary] = useState(null);
  const [creditSummaryLoading, setCreditSummaryLoading] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companyDetails, setCompanyDetails] = useState({});
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [companyData, setCompanyData] = useState(null);
  const [isHistoryMaximized, setIsHistoryMaximized] = useState(false);
  const [historyTransactionTypeFilter, setHistoryTransactionTypeFilter] = useState("");
  const [historyCreditTypeFilter, setHistoryCreditTypeFilter] = useState("");
  const usersPerPage = 4;
  const [showUpdateCreditModal, setShowUpdateCreditModal] = useState(false);
  const [updateCreditData, setUpdateCreditData] = useState({
    accountId: "",
    transactionType: "CREDIT",
    newCredit: 0,
    active: true,
    performedBy: null,
    creditType: "SHORTENING"
  });
  const [showCreditRequestModal, setShowCreditRequestModal] = useState(false);
  const [creditRequestData, setCreditRequestData] = useState({
    accountId: "",
    requestedCredits: "",
    requestedBy: "",
    remarks: "",
    creditType: "SHORTENING"
  });
  const [creditRequestErrors, setCreditRequestErrors] = useState({
    requestedCredits: "",
    remarks: ""
  });
  const [companyLogos, setCompanyLogos] = useState({});
  const [adminAccountId, setAdminAccountId] = useState(null);
  const [accountConfig, setAccountConfig] = useState({
    accountName: "",
    location: "",
    language: "",
    defaultDomain: "",
    urlTracking: false,
    individualTracking: false,
    isActive: false
  });
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [settingsForm, setSettingsForm] = useState({
    isActive: true,
    accountId: ""
  });

  const handlePageChange = (pageNumber) => {
    const nextPage = Math.max(1, Math.min(pageNumber, totalPages || 1));
    setCurrentPage(nextPage);
  };

  const CustomToast = () => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div
        style={{
          backgroundColor: "#00C76F",
          borderRadius: "50%",
          width: "24px",
          height: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: "12px",
        }}
      >
        <FaCheck color="white" size={12} />
      </div>
      <span>Customer Credit Successfully added</span>
    </div>
  );

  const fetchCompanyDetails = async () => {
    try {
      const response = await accountService.getAuthAccount();
      if (response) {
        setCompanyOptions(response);
        const companyMap = {};
        response.forEach((company) => {
          companyMap[company.id] = company.accountName;
        });
        setCompanies(companyMap);
      }
    } catch (error) {
      console.error("Error fetching company details:", error);
      toast.error("Failed to load company details");
    }
  };

  const handleCreateCredit = async () => {
    try {
      const creditAmount = parseInt(newUserData.availableCredits);
      if (isNaN(creditAmount) || creditAmount <= 0) {
        toast.error("Please enter a valid positive number");
        return;
      }

      const response = await creditService.createCredits({
        accountId: newUserData.companyId,
        credit: creditAmount,
        performedBy: userSub,
      });

      if (response.data) {
        setRecords((prevRecords) => [
          ...prevRecords,
          {
            id: response.data.id,
            name: response.data.companyId || response.data.accountId,
            credit: response.data.credit,
            use_credits: "-",
            status: true,
          },
        ]);

        if (selectedCompanyId === newUserData.companyId) {
          setCompanyCredits((prevCredits) => [
            ...prevCredits,
            {
              id: response.data.id,
              availableCredits: response.data.credit,
              isCreditActive: true,
              companyId: response.data.companyId || response.data.accountId,
            },
          ]);
        }

        setShowCreateUserModal(false);
        setNewUserData({
          companyId: "",
          availableCredits: "",
        });
        toast.success("Credits added successfully");
      }
    } catch (error) {
      console.error("Error adding credits:", error);
      toast.error(error.response?.data?.message || "Failed to add credits");
    }
  };

  const fetchUserRecords = async () => {
    try {
      setLoading(true);

      const decodedToken = jwtDecode(token);
      const accountId = decodedToken.accountId;

      if (decodedToken.roles?.includes("SUPERADMIN")) {
        setLoading(false);
        return;
      }

      await fetchCreditSummary(accountId);
      const response = await creditService.getCreditsByAccount(accountId);

      if (!response) {
        throw new Error("No data received");
      }

      const creditsArray = Array.isArray(response)
        ? response
        : [response];

      const transformedData = creditsArray.map((record) => ({
        id: record.id,
        name: record.accountId,
        credit: record.credit,
        use_credits: "-",
        status: record.isCreditActive ? "Active" : "Inactive",
      }));

      setRecords(transformedData);
    } catch (error) {
      console.error("Error fetching user records:", error);
      toast.error(error.response?.data?.message || "Failed to load user records");
    } finally {
      setLoading(false);
    }
  };

  const fetchCompanies = async (shouldFetchLogos = true) => {
    try {
      // For SUPERADMIN fetch all accounts; for ADMIN fetch current account
      const response = isSuperAdmin
        ? await accountService.getAllAccountConfigs()
        : await accountService.getAccountConfigs();

      if (response) {
        const companiesData = Array.isArray(response) ? response : [response];
        setCompanies(companiesData);

        // Only fetch logos if shouldFetchLogos is true (for super admin users)
        if (shouldFetchLogos) {
          const logoPromises = companiesData.map(async (company) => {
            if (company.logo) {
              const logoUrl = await fetchCompanyLogo(company.logo);
              return [company.id, logoUrl];
            }
            return [company.id, null];
          });

          const logos = await Promise.all(logoPromises);
          const logoMap = Object.fromEntries(logos);
          setCompanyLogos(logoMap);
        }

        if (!selectedCompanyId && companiesData.length > 0 && isSuperAdmin) {
          setSelectedCompanyId(companiesData[0].id);
        }
      }
    } catch (err) {
      console.error("Failed to fetch companies:", err);
    }
  };

  const fetchCompanyLogo = async (fileName) => {
    if (!fileName) {
      return null;
    }
    
    try {
      const blob = await accountService.downloadLogo(fileName);
      
      if (blob && blob.size > 0) {
        
        // Ensure we have a proper MIME type for the blob
        let mimeType = blob.type;
        if (!mimeType || mimeType === 'application/octet-stream') {
          // If no MIME type is detected, assume it's a PNG image
          mimeType = 'image/png';
        }
        
        // Convert blob to base64 data URL with proper MIME type
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            let dataUrl = reader.result;
            
            // Ensure the data URL has the correct format: data:image/png;base64,...
            if (dataUrl && !dataUrl.startsWith('data:image/')) {
              // If the data URL doesn't have the proper format, reconstruct it
              const base64Data = dataUrl.split(',')[1] || dataUrl;
              dataUrl = `data:${mimeType};base64,${base64Data}`;
            }
            
            resolve(dataUrl);
          };
          reader.onerror = () => {
            console.error('Error reading blob as data URL in CreditDashboard');
            reject(reader.error);
          };
          reader.readAsDataURL(blob);
        });
      }
      return null;
    } catch (error) {
      console.error("Error fetching company logo in CreditDashboard:", error);
      return null;
    }
  };

  const fetchCreditHistory = async () => {
    try {
      setHistoryLoading(true);
      const formattedStartDate = formatDateForAPI(startDate);
      const formattedEndDate = formatDateForAPI(endDate);

      const accountIdToUse = userRole === "ADMIN" ? adminAccountId : selectedCompanyId;

      if (!accountIdToUse) {
        setHistoryLoading(false);
        return;
      }

      const queryParams = {
        page: historyPage,
        size: historySize,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      };

      const response = await creditService.getCreditHistoryByAccount(accountIdToUse, queryParams);


      if (response) {
        // Handle both possible response structures
        const historyData = response.content || response.data?.content || [];
        const totalRecords = response.totalRecords || response.data?.totalRecords || 0;
        
        
        setCreditHistory(historyData);
        setTotalRecords(totalRecords);
      }
    } catch (error) {
      console.error("Error fetching credit history:", error);
      toast.error("Failed to load credit history");
    } finally {
      setHistoryLoading(false);
    }
  };

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      setToken(storedToken);
      try {
        const decoded = jwtDecode(storedToken);
        const role = decoded?.roles?.[0];
        const accountId = decoded?.accountId;

        setUserRole(role);
        if (role === "ADMIN") {
          setAdminAccountId(accountId);
          setSelectedCompanyId(accountId);
          setNewUserData(prev => ({
            ...prev,
            companyId: accountId
          }));
        }
      } catch (err) {
        console.error("Token decoding failed", err);
        toast.error("Invalid token, please login again");
      }
    } else {
      toast.error("Please login to access this page");
    }
  }, []);

  useEffect(() => {
    if (userRole === "ADMIN" && adminAccountId) {
      fetchTransactionHistory(adminAccountId);
    } else if (userRole === "SUPERADMIN" && selectedCompanyId) {
      fetchTransactionHistory(selectedCompanyId);
    }
  }, [userRole, adminAccountId, selectedCompanyId, historyPage, historySize, startDate, endDate, historyTransactionTypeFilter, historyCreditTypeFilter, token]);

  useEffect(() => {
    if (token && !isSuperAdmin) {
      fetchUserRecords();
    }
  }, [token, isSuperAdmin]);

  useEffect(() => {
    const checkUserRole = () => {
      try {
        const token = localStorage.getItem("token");
        if (token) {
          const decodedToken = jwtDecode(token);
          setIsSuperAdmin(decodedToken.roles.includes("SUPERADMIN"));
          setUserSub(decodedToken.sub);
        }
      } catch (err) {
        console.error("Error decoding token:", err);
        setIsSuperAdmin(false);
      }
    };
    checkUserRole();
  }, []);

  // Keep selectedCompanyId in sync when embedded with external selection
  useEffect(() => {
    if (selectedCompanyIdProp) {
      setSelectedCompanyId(selectedCompanyIdProp);
    }
  }, [selectedCompanyIdProp]);

  useEffect(() => {
    if (token && !isSuperAdmin) {
      try {
        const decodedToken = jwtDecode(token);
        const username = decodedToken.sub;

        userService.getUserByUsername(username)
          .then((response) => {
            if (response && response.accountId) {
              setNewUserData((prev) => ({
                ...prev,
                companyId: response.accountId,
              }));
            }
          });
      } catch (error) {
        console.error("Error setting default company ID:", error);
      }
    }
  }, [token, isSuperAdmin]);

  const handleDeleteClick = (credit) => {
    setCreditToDelete({
      id: credit.id,
      name: credit.companyId,
    });
    setShowDeleteModal(true);
  };
  useEffect(() => {
    if (selectedCompanyId && isSuperAdmin) {
      // Only fetch company credits for super admin when a company is selected
      fetchCompanyCredits(selectedCompanyId);
    }
  }, [selectedCompanyId, isSuperAdmin]);

  const handleEditClick = (credit) => {
    setCreditToEdit(credit);
    setEditFormData({
      id: credit.id,
      companyId: credit.name || credit.companyId || credit.accountId,
      newCredit: "0",
      isCreditActive:
        credit.status === "Active" || credit.isCreditActive === true,
      transactionType: credit.transactionType || "CREDIT",
    });
    setShowEditModal(true);
  };

  const confirmDelete = async () => {
    try {
      await creditService.deleteCredit(creditToDelete.id);

      setRecords((prevRecords) =>
        prevRecords.filter((record) => record.id !== creditToDelete.id)
      );
      if (selectedCompanyId) {
        setCompanyCredits((prevCredits) =>
          prevCredits.filter((credit) => credit.id !== creditToDelete.id)
        );
      }

      setShowDeleteModal(false);
      setCreditToDelete(null);
      toast.success("Credit deleted successfully");
    } catch (error) {
      console.error("Error deleting credit:", error);
      toast.error(error.response?.data?.message || "Failed to delete credit");
    }
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditFormData({
      ...editFormData,
      [name]: value,
    });
  };

  const saveEditChanges = async () => {
    try {
      const creditAmount = parseInt(editFormData.newCredit);
      if (isNaN(creditAmount) || creditAmount <= 0) {
        toast.error("Please enter a valid positive number");
        return;
      }

      const isCreditActive =
        editFormData.isCreditActive === "true" ||
        editFormData.isCreditActive === true;

      const response = await creditService.updateCredits({
        id: editFormData.id,
        accountId: editFormData.companyId,
        transactionType: editFormData.transactionType,
        newCredit: creditAmount,
        isCreditActive: isCreditActive,
        performedBy: userSub,
      });

      setRecords((prevRecords) =>
        prevRecords.map((record) =>
          record.id === editFormData.id
            ? {
                ...record,
                credit: creditAmount,
                status: isCreditActive ? "Active" : "Inactive",
              }
            : record
        )
      );

      if (selectedCompanyId) {
        setCompanyCredits((prevCredits) =>
          prevCredits.map((credit) =>
            credit.id === editFormData.id ? response.data : credit
          )
        );
      }

      setShowEditModal(false);
      setCreditToEdit(null);
      toast.success("Credit updated successfully");

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Error updating credit:", error);
      toast.error(error.response?.data?.message || "Failed to update credit");
    }
  };

  const fetchCreditSummary = async (accountId) => {
    try {
      setCreditSummaryLoading(true);
      const response = await accountService.getAccountSummary(accountId);
      
      // The response might be nested, let's handle both cases
      const summaryData = response.data || response;
      setCreditSummary(summaryData);
    } catch (error) {
      console.error("Error fetching credit summary:", error);
      toast.error("Failed to load credit summary");
    } finally {
      setCreditSummaryLoading(false);
    }
  };

  useEffect(() => {
    if (userRole === "ADMIN" && adminAccountId && !selectedCompanyId) {
      // Only fetch for admin's own account if no company is selected
      fetchCreditSummary(adminAccountId);
    } else if (selectedCompanyId && token) {
      fetchCreditSummary(selectedCompanyId);
    }
  }, [selectedCompanyId, token, userRole, adminAccountId]);

  const getAccountDetails = async (accountId, token) => {
    try {
      const response = await accountService.getAccountConfigById(accountId);

      const { location, language, defaultDomain, accountName, urlTracking, individualTracking, isActive } = response;
      return { 
        location, 
        language, 
        defaultDomain, 
        accountName, 
        urlTracking, 
        individualTracking,
        isActive
      };
    } catch (error) {
      console.error("Error fetching account details:", error);
      return { 
        location: "N/A", 
        language: "N/A", 
        defaultDomain: "N/A", 
        urlTracking: false, 
        individualTracking: false ,
        isActive: false
      };
    }
  };

  useEffect(() => {
    const fetchAccountDetails = async () => {
      const result = await getAccountDetails(selectedCompanyId, token);
      setAccountConfig(result);
    };

    if (selectedCompanyId && token) {
      fetchAccountDetails();
    }
  }, [selectedCompanyId, token]);

  const getTotalUsers = async (accountId) => {
    try {
      const response = await accountService.getAccountSummary(accountId);
      return response.data.userCount ?? 0;
    } catch (error) {
      console.error("Error fetching total users:", error);
      return 0;
    }
  };
  const getTotalCredits = async (accountId) => {
    try {
      const response = await creditService.getCreditsByAccount(accountId);
      return response.data.totalCredit;
    } catch (error) {
      console.error("Error fetching total credits:", error);
      throw error;
    }
  };

  const getCreditsConsumed = async (accountId) => {
    try {
      const response = await creditService.getCreditsByAccount(accountId);
      return Math.abs(response.data.usedBalance);
    } catch (error) {
      console.error("Error fetching credits consumed:", error);
      throw error;
    }
  };

  const fetchCompanyData = async (companyId) => {
    try {
      const response = await accountService.getAccountConfigById(companyId);
      setCompanyData(response);
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  useEffect(() => {
    fetchCompanies(isSuperAdmin);
  }, [isSuperAdmin]);

  useEffect(() => {
    if (selectedCompanyId && isSuperAdmin) {
      fetchCompanyData(selectedCompanyId);
    }
  }, [selectedCompanyId, isSuperAdmin]);
  const fetchCompanyCredits = async (id) => {
    try {
      const response = await creditService.getCreditsByAccount(id);

      const creditsArray = Array.isArray(response)
        ? response
        : [response];
      const transformedCredits = creditsArray.map((credit) => ({
        id: credit.id,
        availableCredits: credit.credit,
        isCreditActive: credit.isCreditActive,
        companyId: credit.accountId,
      }));

      setCompanyCredits(transformedCredits);
    } catch (err) {
      console.error("Failed to fetch company credits:", err);
      setCompanyCredits([]);
    }
  };

  const fetchTransactionHistory = async (accountId) => {
    setHistoryLoading(true);
    // setNoRecordsFound(false);
    try {
      // Use searchCreditHistory instead of getCreditHistoryByAccount to support filters
      // and to be able to fetch debit (consumption) records
      const searchParams = {
        accountId: accountId,
        transactionType: historyTransactionTypeFilter || "",
        exceptConsumption: false, // Allow consumption records to be fetched
        creditType: historyCreditTypeFilter || "",
        fromDate: startDate ? formatDateForAPI(startDate) : "",
        toDate: endDate ? formatDateForAPI(endDate) : "",
      };

      const response = await creditService.searchCreditHistory(searchParams);

      if (response.status === 404) {
        // setNoRecordsFound(true);
        setCreditHistory([]);
        return;
      }
      
      if (response) {
        // Handle both possible response structures
        const historyData = response.content || response.data?.content || [];
        const totalRecords = response.totalRecords || response.data?.totalRecords || 0;
        
        
        setCreditHistory(historyData);
        setTotalRecords(totalRecords);
      }
    } catch (error) {
      console.error("Error fetching transaction history:", error);
      if (error.response && error.response.status === 404) {
        // setNoRecordsFound(true);
      }
    } finally {
      setHistoryLoading(false);
    }
  };

  const handleUpdateCredit = async () => {
    try {
      const response = await creditService.updateCredits({
        accountId: selectedCompanyId || newUserData.companyId,
        transactionType: updateCreditData.transactionType,
        newCredit: parseInt(updateCreditData.newCredit),
        active: updateCreditData.active,
        performedBy: userSub,
        creditType: updateCreditData.creditType
      });

      if (response.data) {
        toast.success("Credits updated successfully");
        setShowUpdateCreditModal(false);
        fetchTransactionHistory(selectedCompanyId || adminAccountId);
        if (selectedCompanyId) {
          fetchCreditSummary(selectedCompanyId);
        }
      }
    } catch (error) {
      console.error("Error updating credits:", error);
      toast.error(error.response?.data?.message || "Failed to update credits");
    }
  };

  const handleCreditRequest = async () => {
    try {
      // Validate before submitting
      const errors = { requestedCredits: "", remarks: "" };
      let hasErrors = false;

      if (!creditRequestData.requestedCredits) {
        errors.requestedCredits = "Requested credits is required";
        hasErrors = true;
      } else if (parseInt(creditRequestData.requestedCredits) <= 0) {
        errors.requestedCredits = "Credits must be greater than 0";
        hasErrors = true;
      } else if (creditRequestData.requestedCredits.length > 5) {
        errors.requestedCredits = "Credits cannot exceed 5 digits";
        hasErrors = true;
      }

      if (!creditRequestData.remarks.trim()) {
        errors.remarks = "Remarks is required";
        hasErrors = true;
      } else {
        const wordCount = creditRequestData.remarks.trim().split(/\s+/).filter(word => word.length > 0).length;
        if (wordCount > 100) {
          errors.remarks = "Remarks cannot exceed 100 words";
          hasErrors = true;
        }
      }

      if (hasErrors) {
        setCreditRequestErrors(errors);
        return;
      }

      setCreditRequestErrors({ requestedCredits: "", remarks: "" });

      const response = await creditService.createCreditRequest({
        accountId: adminAccountId,
        requestedCredits: parseInt(creditRequestData.requestedCredits),
        requestedBy: userSub,
        remarks: creditRequestData.remarks,
        creditType: creditRequestData.creditType
      });

      if (response.data) {
        toast.success("Credit request submitted successfully");
        setShowCreditRequestModal(false);
        setCreditRequestData({
          accountId: "",
          requestedCredits: "",
          requestedBy: "",
          remarks: "",
          creditType: "SHORTENING"
        });
      }
    } catch (error) {
      console.error("Error submitting credit request:", error);
      toast.error(error.response?.data?.message || "Failed to submit credit request");
    }
  };

  const navigate = useNavigate();

  const filteredCreditHistory = creditHistory.filter((history) => {
    if (!searchTerm) return true;

    const searchStr = searchTerm.toLowerCase();
    return (
      history.performedBy?.toLowerCase().includes(searchStr) ||
      history.type?.toLowerCase().includes(searchStr) ||
      history.amount?.toString().includes(searchStr) ||
      new Date(history.transactionTime)
        .toLocaleString("en-US", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
        .toLowerCase()
        .includes(searchStr)
    );
  });


  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredCreditHistory.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const totalPages = Math.ceil(filteredCreditHistory.length / recordsPerPage);
  const maxVisiblePageButtons = 5;
  const getVisiblePageNumbers = () => {
    if (totalPages <= maxVisiblePageButtons) {
      return Array.from({ length: totalPages }, (_, idx) => idx + 1);
    }

    const half = Math.floor(maxVisiblePageButtons / 2);
    let start = Math.max(1, currentPage - half);
    let end = Math.min(totalPages, start + maxVisiblePageButtons - 1);

    if (end - start + 1 < maxVisiblePageButtons) {
      start = Math.max(1, end - maxVisiblePageButtons + 1);
    }

    return Array.from({ length: end - start + 1 }, (_, idx) => start + idx);
  };
  const visiblePageNumbers = getVisiblePageNumbers();

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, historyTransactionTypeFilter, historyCreditTypeFilter, startDate, endDate, selectedCompanyId]);

  useEffect(() => {
    if (totalPages > 0 && currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  const lockTooltip = (
    <Tooltip id="lock-tooltip" className="custom-tooltip">
      This feature is currently disabled. Please contact the system administrator or service provider for assistance.
    </Tooltip>
  );

  
  // Helper function to get credit value with fallbacks
  const getCreditValue = (path, fallback = 0) => {
    if (!creditSummary) return fallback;
    
    // Try different possible response structures
    const value = path(creditSummary) ?? 
                  path({ availableCredit: creditSummary.availableCredit }) ??
                  path({ usedCredit: creditSummary.usedCredit }) ??
                  fallback;
    
    return typeof value === 'number' ? value : fallback;
  };

  const getCreditAmount = (summaryData, category, type) => {
    if (!summaryData) return 0;
    
    const suffix = category === 'availableCredit' ? 'Available' : 'Used';
    const flatKey = `${type}${suffix}`;
    
    if (summaryData[flatKey] !== undefined && summaryData[flatKey] !== null) {
      return summaryData[flatKey];
    }

    const categoryData = summaryData[category];
    
    if (Array.isArray(categoryData)) {
      const found = categoryData.find(item => item[type] !== undefined && item[type] !== null);
      return found ? found[type] : 0;
    }
    
    if (categoryData && typeof categoryData === 'object') {
      return categoryData[type] ?? 0;
    }
    
    return 0;
  };

  const handleStatusChange = async (accountId, newStatus) => {
    try {
    
      const creditsResponse = await creditService.getCreditsByAccount(accountId);

      const creditsArray = Array.isArray(creditsResponse)
        ? creditsResponse
        : [creditsResponse];

      const shorteningCredit = creditsArray.find(
        credit => credit.creditType === "SHORTENING"
      );

      if (!shorteningCredit) {
        toast.error("No SHORTENING credit found for this account");
        return;
      }

 
      const response = await creditService.updateCreditStatus({
        creditId: shorteningCredit.id,
        active: newStatus
      });

      if (response.data) {
       
        setAccountConfig(prev => ({
          ...prev,
          isActive: newStatus
        }));
        
        toast.success(`Credit status updated successfully`);
      }
    } catch (error) {
      console.error("Error updating credit status:", error);
      toast.error(error.response?.data?.message || "Failed to update credit status");
    }
  };

  return (
    <Container fluid className="ps-0 pb-4 pe-0 overflow-hidden bg-white">
      <ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      
      {isSuperAdmin ? (
        <Row>
          {/* Left Column - Company List */}
          {/* <Col md={3}>  */}

          {/* </Col> */}
          {!embedded && (
          <Col lg={4}>
            <CompanySidebar
              companies={companies}
              selectedCompanyId={selectedCompanyId}
              onSelectCompany={async (id) => {
                setSelectedCompanyId(id);
                const company = companies.find((c) => c.id === id);
                setSelectedCompany(company);
                await fetchTransactionHistory(id);
              }}
              searchTerm={companySearchTerm}
              onSearchTermChange={setCompanySearchTerm}
              companyLogos={companyLogos}
              className="tab-card"
            />
          </Col>
          )}
          {/* </Col> */}
          {/* Right Column - Company Details */}

          <Col md={embedded ? 12 : 8}>
            {selectedCompanyId && (
              <>
                <Card className="mb-3">
                  <Card.Body className="p-0">

                    <h6 className="company-dark-bg-logo mb-2 fs-13">
                      {companies.find((c) => c.id === selectedCompanyId)
                        ?.accountName || "Company Name Not Found"}
                    </h6>
                    {/* <div className="d-flex justify-content-end">
                      <Button
                        variant="success"
                        className="rounded-pill"
                        style={{ backgroundColor: '#FF812E' }}
                      >
                        Upgrade
                      </Button>

                    </div> */}
                    <div className="company-detail w-100 d-flex align-items-center gap-2 justify-content-between mb-0" style={{padding: '8px 8px 10px'}}>
                      <div className="d-flex flex-column">
                        <div className="d-flex align-items-center gap-2">
                          <Image
                            width={40}
                            height={40}
                            className="me-2 rounded-circle object-contain"
                            style={{ border: "1px solid #f4f4f4" }}
                            src={
                              companyLogos[selectedCompanyId] || companyImage
                            }
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = companyImage;
                            }}
                            alt={companyDetails.accountName}
                          />
                          <div>
                            <h6
                              className="text-101828 ls-0 mb-0 text-capitalize fw-600"
                              style={{ fontSize: "13px" }}
                            >
                              {accountConfig.accountName || ""}
                            </h6>
                            <div className="d-flex align-items-center gap-3">
                              <p className="mb-0">
                                <span className="fs-12">
                                  Location : {accountConfig.location || "N/A"}
                                </span>
                              </p>
                              <p className="mb-0">
                                <span className="fs-12">
                                  Language : {accountConfig.language || "N/A"}
                                </span>
                              </p>
                              <p className="mb-0">
                                <span
                                  className="fs-12"
                                  style={{
                                    width: "250px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    position: "relative",
                                    display: "block",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Default Domain :{" "}
                                  <span
                                    title={accountConfig.defaultDomain || "N/A"}
                                  >
                                    {accountConfig.defaultDomain || "N/A"}
                                  </span>
                                </span>
                              </p>
                              <div className="d-flex align-items-center gap-2">
                                {accountConfig?.isActive ? (
                                  <span className="badge-custom badge-border-success badge badge-before position-relative ps-3 bg-success">
                                    Active
                                  </span>
                                ) : (
                                  <span className="badge-custom badge-border-danger badge badge-before position-relative ps-3 bg-danger">
                                    Inactive
                                  </span>
                                )}
                                {userRole === "SUPERADMIN" && (
                                  <span
                                    className="badge-custom badge-border-success badge position-relative ps-3 bg-success d-flex align-items-center gap-1"
                                    onClick={() => {
                                      setSettingsForm({
                                        isActive: accountConfig.isActive,
                                        accountId: selectedCompanyId
                                      });
                                      setShowSettingsModal(true);
                                    }}
                                    title="Account Settings"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <FaCog size={12} />
                                    <span className="fs-12"></span>
                                  </span>
                                )}
                              </div>
                            </div>
                            
                          </div>
                        </div>
                      </div>
                      <div></div>
                    </div>
                  </Card.Body>
                </Card>

                {/* Summary Cards */}
                <Row className="mb-3">
                  <Col md={3}>
                    <Card className="green-gradient h-100">
                      <Card.Body>
                        <div className="d-flex align-items-center gap-2 pt-2 pb-2">
                          <div className="card-statics-icon-two card-statics-icon-two-size bg-white">
                            <Image style={{width:'17px', height:'17px'}} src={creditsTwoIcon} />
                          </div>
                          <div>
                            <h6 className="fs-12 text-white fw-400 mb-0">Available Shortening</h6>
                            <p className="mb-0 Raleway fw-700 text-white fs-15">
                              {creditSummaryLoading ? (
                                <span className="spinner-border spinner-border-sm" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </span>
                              ) : (
                                getCreditAmount(creditSummary, 'availableCredit', 'shortening').toLocaleString()
                              )}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>




                  <Col md={3}>
                    <Card className="orange-gradient h-100">
                      <Card.Body>
                        <div className="d-flex align-items-center gap-2 pt-2 pb-2">
                          <div className="card-statics-icon-two bg-white card-statics-icon-two-size">
                            <Image style={{width:'17px', height:'17px'}} src={creditsTwoIcon} />
                          </div>
                          <div>
                            <h6 className="fs-12 text-white fw-400 mb-0">Consumed Shortening</h6>
                            <p className="mb-0 Raleway fw-700 text-white fs-15">
                              {getCreditAmount(creditSummary, 'usedCredit', 'shortening').toLocaleString()}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col md={3}>
                    {isSuperAdmin ? (
                      <Card className="green-gradient h-100">
                        <Card.Body>
                          <div className="d-flex align-items-center gap-2 pt-2 pb-2">
                            <div className="card-statics-icon-two bg-white card-statics-icon-two-size">
                              <Image style={{width:'17px', height:'17px'}} src={creditsTwoIcon} />
                            </div>
                            <div>
                              <h6 className="fs-12 text-white fw-400 mb-0">Available Tracking</h6>
                              <p className="mb-0 Raleway fw-700 text-white fs-15">
                                {getCreditAmount(creditSummary, 'availableCredit', 'tracking').toLocaleString()}
                              </p>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    ) : accountConfig.urlTracking ? (
                  <Card className="green-gradient h-100">
                    <Card.Body>
                      <div className="d-flex align-items-center gap-2 pt-2 pb-2">
                        <div className="card-statics-icon-two bg-white card-statics-icon-two-size">
                          <Image style={{width:'17px', height:'17px'}} src={creditsTwoIcon} />
                            </div>
                            <div>
                              <h6 className="fs-12 text-white fw-400 mb-0">Available Tracking</h6>
                              <p className="mb-0 Raleway fw-700 text-white fs-15">
                                {getCreditAmount(creditSummary, 'availableCredit', 'tracking').toLocaleString()}
                              </p>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>This feature is currently disabled. Please contact the system administrator.</Tooltip>
                        }
                      >
                        <Card className="green-gradient h-100 position-relative">
                          <div className="lock-icon-container">
                            <div className="d-flex align-items-center justify-content-center">
                              <Image 
                                src={disable}
                                alt="Disabled"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  objectFit: "contain" 
                                }}
                              />
                            </div>
                          </div>
                          <Card.Body>
                            <div className="d-flex align-items-center gap-2 pt-2 pb-2">
                              <div className="card-statics-icon-two bg-white card-statics-icon-two-size">
                                <Image style={{width:'17px', height:'17px'}} src={creditsTwoIcon} />
                              </div>
                              <div>
                                <h6 className="fs-12 text-white fw-400 mb-0">Available Tracking</h6>
                                <p className="mb-0 Raleway fw-700 text-white fs-15">
                                  {getCreditAmount(creditSummary, 'availableCredit', 'tracking').toLocaleString()}
                                </p>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </OverlayTrigger>
                    )}
                  </Col>
                  
                  <Col md={3}>
                    {isSuperAdmin ? (
                      <Card className="orange-gradient h-100">
                        <Card.Body>
                          <div className="d-flex align-items-center gap-2 pt-2 pb-2">
                            <div className="card-statics-icon-two bg-white card-statics-icon-two-size">
                              <Image style={{width:'17px', height:'17px'}} src={creditsTwoIcon} />
                            </div>
                            <div>
                              <h6 className="fs-12 text-white fw-400 mb-0">Consumed Tracking</h6>
                              <p className="mb-0 Raleway fw-700 text-white fs-15">
                                {getCreditAmount(creditSummary, 'usedCredit', 'tracking').toLocaleString()}
                              </p>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    ) : accountConfig.urlTracking ? (
                      <Card className="orange-gradient h-100">
                        <Card.Body>
                          <div className="d-flex align-items-center gap-2 pt-2 pb-2">
                            <div className="card-statics-icon-two bg-white card-statics-icon-two-size">
                              <Image style={{width:'17px', height:'17px'}} src={creditsTwoIcon} />
                            </div>
                            <div>
                              <h6 className="fs-12 text-white fw-400 mb-0">Consumed Tracking</h6>
                              <p className="mb-0 Raleway fw-700 text-white fs-15">
                                {getCreditAmount(creditSummary, 'usedCredit', 'tracking').toLocaleString()}
                              </p>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>This feature is currently disabled. Please contact the system administrator.</Tooltip>
                        }
                      >
                        <Card className="orange-gradient h-100 position-relative">
                          <div className="lock-icon-container">
                            <div className="d-flex align-items-center justify-content-center">
                              <Image 
                                src={disable}
                                alt="Disabled"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  objectFit: "contain"  
                                }}
                              />
                            </div>
                          </div>
                          <Card.Body>
                            <div className="d-flex align-items-center gap-2 pt-2 pb-2">
                              <div className="card-statics-icon-two bg-white card-statics-icon-two-size">
                                <Image style={{width:'17px', height:'17px'}} src={creditsTwoIcon} />
                              </div>
                              <div>
                                <h6 className="fs-12 text-white fw-400 mb-0">Consumed Tracking</h6>
                              <p className="mb-0 Raleway fw-700 text-white fs-15">
                                {getCreditAmount(creditSummary, 'usedCredit', 'tracking').toLocaleString()}
                              </p>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </OverlayTrigger>
                    )}
                  </Col>
                </Row>

                {/* Credit History Table */}
                <Card>
                  <Card.Body>
                    <h5 className="mb-3">Credit History</h5>

                    <div className="d-block d-md-flex align-items-center gap-3 mb-4 flex-wrap">
                      <div
                        className="position-relative"
                        style={{ width: "250px" }}
                      >
                        <Form.Control
                          type="text"
                          className="form-control"
                          placeholder="Search Name"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          style={{ width: "100%" }}
                        />
                        <Image
                          style={{ right: "15px", top: "12px" }}
                          width={15}
                          className="position-absolute"
                          src={searchIcon}
                        />
                      </div>
                      <div
                        className="d-flex align-items-center mt-2 mt-md-0 border overflow-hidden"
                        style={{ borderRadius: "8px", width: "250px" }}
                      >
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => {
                            setStartDate(date);
                            setCurrentPage(1);
                          }}
                          selectsStart
                          startDate={startDate}
                          endDate={endDate}
                          className="border-0 form-control"
                        />
                        <span className="mx-2">⇆</span>
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => {
                            setEndDate(date);
                            setCurrentPage(1);
                          }}
                          selectsEnd
                          startDate={startDate}
                          endDate={endDate}
                          minDate={startDate}
                          className="border-0 form-control"
                        />
                        <CiCalendar
                          style={{ fontSize: "36px" }}
                          className="ms-2 me-2"
                        />
                      </div>
                      <Form.Select
                        className="mt-2 mt-md-0"
                        style={{ width: "200px" }}
                        value={historyTransactionTypeFilter}
                        onChange={(e) => {
                          setHistoryTransactionTypeFilter(e.target.value);
                          setCurrentPage(1);
                        }}
                      >
                        <option value="">All Transaction Types</option>
                        <option value="CREDIT">Credit</option>
                        <option value="DEBIT">Debit</option>
                      </Form.Select>
                      <Form.Select
                        className="mt-2 mt-md-0"
                        style={{ width: "200px" }}
                        value={historyCreditTypeFilter}
                        onChange={(e) => {
                          setHistoryCreditTypeFilter(e.target.value);
                          setCurrentPage(1);
                        }}
                      >
                        <option value="">All Credit Types</option>
                        <option value="SHORTENING">Shortening</option>
                        <option value="TRACKING">Tracking</option>
                      </Form.Select>

                      {(historyTransactionTypeFilter || historyCreditTypeFilter || searchTerm || areDatesModified()) && (
                        <Button
                          variant="light"
                          size="sm"
                          className="d-flex align-items-center gap-2 mt-2 mt-md-0"
                          style={{
                            border: "1px solid #EAECEE",
                            borderRadius: "8px",
                            padding: "9px 15px",
                          }}
                          onClick={() => {
                            setHistoryTransactionTypeFilter("");
                            setHistoryCreditTypeFilter("");
                            setSearchTerm("");
                            setCurrentPage(1);
                            const defaultStart = new Date();
                            defaultStart.setMonth(defaultStart.getMonth() - 1);
                            setStartDate(defaultStart);
                            setEndDate(new Date());
                          }}
                        >
                          <FcClearFilters size={12} />
                          <span className="fw-400 fs-12">Clear All</span>
                        </Button>
                      )}
                    </div>

                    {currentRecords && currentRecords.length > 0 ? (
                      <Table
                        responsive
                        hover
                        className="mb-0 table-hover-border"
                      >
                        <thead>
                          <tr>
                            <th style={{ width: "150px" }}>
                              Transaction Time
                            </th>
                            <th>Transaction Type</th>
                            <th>Credit Type</th>
                            <th>Amount</th>
                            <th style={{ width: "150px" }}>Performed By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentRecords.map((history) => (
                            <tr key={history.id}>
                              <td
                                style={{
                                  minWidth: "220px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {new Date(history.transactionTime)
                                  .toLocaleString("en-US", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })
                                  .replace(",", " |")}
                              </td>
                              <td>
                                <span
                                  className={`badge bg-${
                                    history.type === "CREDIT"
                                      ? "success"
                                      : "danger"
                                  }`}
                                >
                                  {history.type}
                                </span>
                              </td>
                              <td>
                                <span className="badge bg-info">
                                  {history.creditType}
                                </span>
                              </td>
                              <td>{history.amount.toLocaleString()}</td>
                              <td>{history.performedBy}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    ) : (
                      <div className="text-center py-3 text-muted">
                        {searchTerm
                          ? "No matching records found"
                          : "No credit history found"}
                      </div>
                    )}

                    {currentRecords.length > 0 && (
                      <div className="d-flex justify-content-center mt-4">
                        <nav>
                          <ul className="pagination">
                            <li
                              className={`page-item ${
                                currentPage === 1 ? "disabled" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => handlePageChange(1)}
                                disabled={currentPage === 1}
                              >
                                {"<<"}
                              </button>
                            </li>
                            <li
                              className={`page-item ${
                                currentPage === 1 ? "disabled" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() =>
                                  handlePageChange(currentPage - 1)
                                }
                                disabled={currentPage === 1}
                              >
                                {"<"}
                              </button>
                            </li>
                            {visiblePageNumbers[0] > 1 && (
                              <>
                                <li className="page-item">
                                  <button
                                    className="page-link"
                                    onClick={() => handlePageChange(1)}
                                  >
                                    1
                                  </button>
                                </li>
                                {visiblePageNumbers[0] > 2 && (
                                  <li className="page-item disabled">
                                    <span className="page-link">...</span>
                                  </li>
                                )}
                              </>
                            )}
                            {visiblePageNumbers.map((number) => (
                              <li
                                key={number}
                                className={`page-item ${
                                  currentPage === number ? "active" : ""
                                }`}
                              >
                                <button
                                  className="page-link"
                                  onClick={() => handlePageChange(number)}
                                >
                                  {number}
                                </button>
                              </li>
                            ))}
                            {visiblePageNumbers[visiblePageNumbers.length - 1] < totalPages && (
                              <>
                                {visiblePageNumbers[visiblePageNumbers.length - 1] < totalPages - 1 && (
                                  <li className="page-item disabled">
                                    <span className="page-link">...</span>
                                  </li>
                                )}
                                <li className="page-item">
                                  <button
                                    className="page-link"
                                    onClick={() => handlePageChange(totalPages)}
                                  >
                                    {totalPages}
                                  </button>
                                </li>
                              </>
                            )}
                            <li
                              className={`page-item ${
                                currentPage === totalPages ? "disabled" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                              >
                                {">"}
                              </button>
                            </li>
                            <li
                              className={`page-item ${
                                currentPage === totalPages ? "disabled" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => handlePageChange(totalPages)}
                                disabled={currentPage === totalPages}
                              >
                                {">>"}
                              </button>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </>
            )}
          </Col>
        </Row>
      ) : (
        /* Admin part */
        

        
        <Card className="card-nostyle card ps-2 pe-2" style={{marginTop:'70px'}}>
          <Card.Body className="pt-2">
            <div className="d-block d-md-flex justify-content-between align-items-center mb-4">
              <div className="d-flex justify-content-end w-100">
                {isSuperAdmin ? (
                  <>
                    <Button
                      variant="success"
                      className="ms-0 ms-md-2 mt-2 mt-md-0"
                      style={{ borderRadius: "8px" }}
                      onClick={() => setShowCreateUserModal(true)}
                    >
                      <FontAwesomeIcon icon={faPlus} className="fs-16 me-1" />{" "}
                      Add Credit
                    </Button>
                    <Button
                      variant="primary"
                      className="ms-0 ms-md-2 mt-2 mt-md-0"
                      style={{ borderRadius: "8px" }}
                      onClick={() => setShowUpdateCreditModal(true)}
                    >
                      Update Credit
                    </Button>
                  </>
                ) : (
                  userRole === "ADMIN" && (
                    <>
                      
                      
                                   <div className="custom-domain-containers w-100">
            <div
              className="d-flex justify-content-between ps-0 pe-0 align-items-center pb-2"
              style={{ borderBottom: "1px solid #EAECF0" }}
            >
              <h4 className="mb-0 bg-white br-radius-12 rounded-bottom-0 fs-20 poppins fw-600">
                <Image src={creditManagementIcon} className="me-1" width="20" />{" "}
                Credit Management Dashboard
              </h4>

                                    <div className="d-flex gap-2">
                        <Button
                          variant="success"
                          className="ms-0 ms-md-2 mt-2 mt-md-0"
                          style={{ borderRadius: "8px" }}
                          onClick={() => setShowCreditRequestModal(true)}
                        >
                          <FontAwesomeIcon
                            icon={faPlus}
                            className="fs-16 me-1"
                          />{" "}
                          Create Request
                        </Button>
                        <Button
                          variant="success"
                          className="ms-0 ms-md-2 mt-2 mt-md-0"
                          style={{ borderRadius: "8px" }}
                          onClick={() => navigate("/credit-requests")}
                        >
                          View Requests
                        </Button>
                      </div>
            </div>
          </div>


                    </>
                  )
                )}
              </div>
            </div>

            {loading ? (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <Row className="mb-3">
                <Col md={3}>
                  <Card className="green-gradient h-100">
                    <Card.Body>
                      <div className="d-flex align-items-center gap-2 pt-2 pb-2">
                        <div className="card-statics-icon-two bg-white">
                          <Image className="w-100" src={creditsTwoIcon} />
                        </div>
                        <div>
                          <h6 className="fs-12 text-white fw-400 mb-0">Available Shortening</h6>
                          <p className="mb-0 Raleway fw-700 text-white fs-20">
                            {getCreditAmount(creditSummary, 'availableCredit', 'shortening').toLocaleString()}
                          </p>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card className="orange-gradient h-100">
                    <Card.Body>
                      <div className="d-flex align-items-center gap-2 pt-2 pb-2">
                        <div className="card-statics-icon-two bg-white card-statics-icon-two-size">
                          <Image style={{width:'17px', height:'17px'}} src={creditsTwoIcon} />
                        </div>
                        <div>
                          <h6 className="fs-12 text-white fw-400 mb-0">Consumed Shortening</h6>
                          <p className="mb-0 Raleway fw-700 text-white fs-20">
                            {getCreditAmount(creditSummary, 'usedCredit', 'shortening').toLocaleString()}
                          </p>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={3}>
                  {isSuperAdmin ? (
                    <Card className="green-gradient h-100">
                      <Card.Body>
                        <div className="d-flex align-items-center gap-2 pt-2 pb-2">
                          <div className="card-statics-icon-two bg-white card-statics-icon-two-size">
                            <Image style={{width:'17px', height:'17px'}} src={creditsTwoIcon} />
                          </div>
                          <div>
                            <h6 className="fs-12 text-white fw-400 mb-0">Available Tracking</h6>
                            <p className="mb-0 Raleway fw-700 text-white fs-15">
                              {getCreditAmount(creditSummary, 'availableCredit', 'tracking').toLocaleString()}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  ) : accountConfig.urlTracking ? (
                    <Card className="green-gradient h-100">
                      <Card.Body>
                        <div className="d-flex align-items-center gap-2 pt-2 pb-2">
                          <div className="card-statics-icon-two bg-white card-statics-icon-two-size">
                            <Image style={{width:'17px', height:'17px'}} src={creditsTwoIcon} />
                          </div>
                          <div>
                            <h6 className="fs-12 text-white fw-400 mb-0">Available Tracking</h6>
                            <p className="mb-0 Raleway fw-700 text-white fs-20">
                              {getCreditAmount(creditSummary, 'availableCredit', 'tracking').toLocaleString()}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  ) : (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip>This feature is currently disabled. Please contact the system administrator.</Tooltip>
                      }
                    >
                      <Card className="green-gradient h-100 position-relative">
                        <div className="lock-icon-container">
                          <div className="d-flex align-items-center justify-content-center">
                            <Image 
                              src={disable}
                              alt="Disabled"
                              style={{
                                width: "16px",
                                height: "16px",
                                objectFit: "contain"  
                              }}
                            />
                          </div>
                        </div>
                        <Card.Body>
                          <div className="d-flex align-items-center gap-2 pt-2 pb-2">
                            <div className="card-statics-icon-two bg-white card-statics-icon-two-size">
                              <Image style={{width:'17px', height:'17px'}} src={creditsTwoIcon} />
                            </div>
                            <div>
                              <h6 className="fs-12 text-white fw-400 mb-0">Available Tracking</h6>
                              <p className="mb-0 Raleway fw-700 text-white fs-15">
                                {getCreditAmount(creditSummary, 'availableCredit', 'tracking').toLocaleString()}
                              </p>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </OverlayTrigger>
                  )}
                </Col>

                <Col md={3}>
                  {isSuperAdmin ? (
                    <Card className="orange-gradient h-100">
                      <Card.Body>
                        <div className="d-flex align-items-center gap-2 pt-2 pb-2">
                          <div className="card-statics-icon-two bg-white card-statics-icon-two-size">
                            <Image style={{width:'17px', height:'17px'}} src={creditsTwoIcon} />
                          </div>
                          <div>
                            <h6 className="fs-12 text-white fw-400 mb-0">Consumed Tracking</h6>
                            <p className="mb-0 Raleway fw-700 text-white fs-15">
                              {getCreditAmount(creditSummary, 'usedCredit', 'tracking').toLocaleString()}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  ) : accountConfig.urlTracking ? (

                    <Card className="orange-gradient h-100">
                      <Card.Body>
                        <div className="d-flex align-items-center gap-2 pt-2 pb-2">
                          <div className="card-statics-icon-two bg-white card-statics-icon-two-size">
                            <Image style={{width:'17px', height:'17px'}} src={creditsTwoIcon} />
                          </div>
                          <div>
                            <h6 className="fs-12 text-white fw-400 mb-0">Consumed Tracking</h6>
                            <p className="mb-0 Raleway fw-700 text-white fs-20">
                              {getCreditAmount(creditSummary, 'usedCredit', 'tracking').toLocaleString()}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  ) : (
            
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip>This feature is currently disabled. Please contact the system administrator.</Tooltip>
                      }
                    >
                      <Card className="orange-gradient h-100 position-relative">
                        <div className="lock-icon-container">
                          <div className="d-flex align-items-center justify-content-center">
                            <Image 
                              src={disable}
                              alt="Disabled"
                              style={{
                                width: "16px",
                                height: "16px",
                                objectFit: "contain"  
                              }}
                            />
                          </div>
                        </div>
                        <Card.Body>
                          <div className="d-flex align-items-center gap-2 pt-2 pb-2">
                            <div className="card-statics-icon-two bg-white card-statics-icon-two-size">
                              <Image style={{width:'17px', height:'17px'}} src={creditsTwoIcon} />
                            </div>
                            <div>
                              <h6 className="fs-12 text-white fw-400 mb-0">Consumed Tracking</h6>
                              <p className="mb-0 Raleway fw-700 text-white fs-15">
                                {getCreditAmount(creditSummary, 'usedCredit', 'tracking').toLocaleString()}
                              </p>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </OverlayTrigger>
                  )}
                </Col>
              </Row>
            )}

            <Card className="card-nostyle card mt-4 ps-0 pe-0">
              <Card.Body className="pt-2 p-0">
                <h5 className="mb-4">Credit History</h5>

                <div className="d-block d-md-flex align-items-center gap-3">
                  <div className="position-relative" style={{ width: "250px" }}>
                    <Form.Control
                      type="text"
                      className="form-control"
                      placeholder="Search Name"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{ width: "100%" }}
                    />
                    <Image
                      style={{ right: "15px", top: "12px" }}
                      width={15}
                      className="position-absolute"
                      src={searchIcon}
                    />
                  </div>
                  <div
                    className="d-flex align-items-center mt-2 mt-md-0 border overflow-hidden"
                    style={{ borderRadius: "8px", width: "250px" }}
                  >
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => {
                        setStartDate(date);
                        setCurrentPage(1);
                      }}
                      selectsStart
                      startDate={startDate}
                      endDate={endDate}
                      className="border-0 form-control"
                    />
                    <span className="mx-2">⇆</span>

                    <DatePicker
                      selected={endDate}
                      onChange={(date) => {
                        setEndDate(date);
                        setCurrentPage(1);
                      }}
                      selectsEnd
                      startDate={startDate}
                      endDate={endDate}
                      minDate={startDate}
                      className="border-0 form-control"
                    />
                    <CiCalendar
                      style={{ fontSize: "36px" }}
                      className="ms-2 me-2"
                    />
                  </div>

                  {(searchTerm || areDatesModified()) && (
                    <Button
                      variant="light"
                      size="sm"
                      className="d-flex align-items-center gap-2 mt-2 mt-md-0"
                      style={{
                        border: "1px solid #EAECEE",
                        borderRadius: "8px",
                        padding: "9px 15px",
                      }}
                      onClick={() => {
                        setSearchTerm("");
                        setCurrentPage(1);
                        const defaultStart = new Date();
                        defaultStart.setMonth(defaultStart.getMonth() - 1);
                        setStartDate(defaultStart);
                        setEndDate(new Date());
                      }}
                    >
                      <FcClearFilters size={12} />
                      <span className="fw-400 fs-12">Clear All</span>
                    </Button>
                  )}
                </div>
                {historyLoading ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <>
                    {userRole === "ADMIN" && (
                      <>
                        {/* <h5 className="mb-3">Your Credit History</h5> */}

                        {currentRecords && currentRecords.length > 0 ? (
                          <Table
                            responsive
                            hover
                            className="mb-0 table-hover-border mt-3"
                          >
                            <thead>
                              <tr>
                                <th style={{ width: "150px" }}>
                                  Transaction Time
                                </th>
                                <th>Transaction Type</th>
                                <th>Credit Type</th>
                                <th>Amount</th>
                                <th style={{ width: "150px" }}>Performed By</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentRecords.map((history) => (
                                <tr key={history.id}>
                                  <td
                                    style={{
                                      minWidth: "220px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {new Date(history.transactionTime)
                                      .toLocaleString("en-US", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true,
                                      })
                                      .replace(",", " |")}
                                  </td>
                                  <td>
                                    <span
                                      className={`badge bg-${
                                        history.type === "CREDIT"
                                          ? "success"
                                          : "danger"
                                      }`}
                                    >
                                      {history.type}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="badge bg-info">
                                      {history.creditType}
                                    </span>
                                  </td>
                                  <td>{history.amount.toLocaleString()}</td>
                                  <td>{history.performedBy}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        ) : (
                          <div className="text-center py-3 text-muted"></div>
                        )}
                      </>
                    )}

                    {currentRecords.length === 0 && (
                      <div className="text-center py-4">
                        <p className="text-muted mb-0">
                          No credit history found
                        </p>
                      </div>
                    )}

                    <div className="d-flex justify-content-center mt-4">
                      <nav>
                        <ul className="pagination">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(1)}
                              disabled={currentPage === 1}
                            >
                              {"<<"}
                            </button>
                          </li>
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              {"<"}
                            </button>
                          </li>
                          {visiblePageNumbers[0] > 1 && (
                            <>
                              <li className="page-item">
                                <button
                                  className="page-link"
                                  onClick={() => handlePageChange(1)}
                                >
                                  1
                                </button>
                              </li>
                              {visiblePageNumbers[0] > 2 && (
                                <li className="page-item disabled">
                                  <span className="page-link">...</span>
                                </li>
                              )}
                            </>
                          )}
                          {visiblePageNumbers.map((number) => (
                            <li
                              key={number}
                              className={`page-item ${
                                currentPage === number ? "active" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => handlePageChange(number)}
                              >
                                {number}
                              </button>
                            </li>
                          ))}
                          {visiblePageNumbers[visiblePageNumbers.length - 1] < totalPages && (
                            <>
                              {visiblePageNumbers[visiblePageNumbers.length - 1] < totalPages - 1 && (
                                <li className="page-item disabled">
                                  <span className="page-link">...</span>
                                </li>
                              )}
                              <li className="page-item">
                                <button
                                  className="page-link"
                                  onClick={() => handlePageChange(totalPages)}
                                >
                                  {totalPages}
                                </button>
                              </li>
                            </>
                          )}
                          <li
                            className={`page-item ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              {">"}
                            </button>
                          </li>
                          <li
                            className={`page-item ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(totalPages)}
                              disabled={currentPage === totalPages}
                            >
                              {">>"}
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </>
                )}
              </Card.Body>
            </Card>
          </Card.Body>
        </Card>
      )}

      <Modal
        show={showCreateUserModal}
        onHide={() => setShowCreateUserModal(false)}
        centered
        size="md"
      >
        <Modal.Header closeButton className="border-0 bg-white">
          <Modal.Title className="w-100 text-center text-101828 mb-1 fw-600 ls-minus-0 fs-14">
            Add Credits
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 pt-0">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="fs-12 form-label ls-spacing-2 text-616161 form-label">
                Account Name
              </Form.Label>
              {isSuperAdmin ? (
                <Form.Select
                  value={newUserData.companyId}
                  onChange={(e) =>
                    setNewUserData({
                      ...newUserData,
                      companyId: e.target.value,
                    })
                  }
                  className="rounded-pill"
                  style={{ color: "#000", fontWeight: "400" }}
                >
                  <option value="" style={{ color: "#6F7074" }}>
                    Select Company
                  </option>
                  {companies.map((company) => (
                    <option
                      key={company.id}
                      value={company.id}
                      style={{ color: "#6F7074" }}
                    >
                      {company.accountName}
                    </option>
                  ))}
                </Form.Select>
              ) : (
                <Form.Control
                  type="text"
                  value={
                    companies.find((c) => c.id === newUserData.companyId)
                      ?.accountName || newUserData.companyId
                  }
                  disabled
                  className="rounded-pill"
                  style={{
                    color: "#000",
                    fontWeight: "400",
                    backgroundColor: "#e9ecef",
                  }}
                />
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fs-12 form-label ls-spacing-2 text-616161 form-label">
                Credit Volume
              </Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter credit Volume"
                value={newUserData.availableCredits}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || /^\d+$/.test(value)) {
                    setNewUserData({ ...newUserData, availableCredits: value });
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === ".") {
                    e.preventDefault();
                  }
                }}
                min="0"
                step="1"
                className="rounded-pill"
                style={{ color: "#000" }}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 p-3">
          <div className="d-flex gap-3 w-75">
            <Button
              variant="danger"
              className="flex-grow-1 br-radius-8"
              onClick={() => setShowCreateUserModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="success"
              className="flex-grow-1 br-radius-8"
              onClick={handleCreateCredit}
              disabled={!newUserData.companyId || !newUserData.availableCredits}
            >
              Add Credits
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
        size="sm"
        className="success-notification-modal"
      >
        <Modal.Body className="p-3 text-center">
          <div className="d-flex align-items-center">
            <div
              className="rounded-circle bg-success d-flex align-items-center justify-content-center me-3"
              style={{ width: "24px", height: "24px" }}
            >
              <FaCheck color="white" size={12} />
            </div>
            <span>Customer Credit Successfully added</span>
            <Button
              variant="link"
              className="ms-2 p-0 text-dark"
              onClick={() => setShowSuccessModal(false)}
              style={{ textDecoration: "none", fontSize: "20px" }}
            >
              ×
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
        size="md"
      >
        <Modal.Body className="text-center p-4">
          <h5 className="text-101828 mb-1 fw-600 ls-minus-0 fs-14">
            Confirm Delete
          </h5>
          <p className="fw-400 fs-12 mb-1">
            Are you sure you want to delete this credit?
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 p-3">
          <div className="d-flex gap-3 w-75">
            <Button
              variant="light"
              className="flex-grow-1 br-radius-8"
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="flex-grow-1 br-radius-8"
              onClick={confirmDelete}
            >
              Yes, Delete
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
        size="md"
      >
        <Modal.Header closeButton className="border-0 bg-white">
          <Modal.Title className="w-100 text-center text-101828 mb-1 fw-600 ls-minus-0 fs-14">
            Edit Credit
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 pt-0">
          {creditToEdit && (
            <Form>
              <Form.Group className="mb-3">
                <Form.Label className="fs-12 form-label ls-spacing-2 text-616161 form-label">
                  Transaction Type
                </Form.Label>
                <Form.Select
                  name="transactionType"
                  value={editFormData.transactionType}
                  onChange={handleEditFormChange}
                  className="rounded-pill"
                >
                  <option value="CREDIT">CREDIT</option>
                  <option value="DEBIT">DEBIT</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="fs-12 form-label ls-spacing-2 text-616161 form-label">
                  Credits
                </Form.Label>
                <Form.Control
                  type="number"
                  name="newCredit"
                  placeholder="Enter credits"
                  className="rounded-pill"
                  value={editFormData.newCredit}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || /^\d+$/.test(value)) {
                      handleEditFormChange(e);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === ".") {
                      e.preventDefault();
                    }
                  }}
                  min="0"
                  step="1"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="fs-12 form-label ls-spacing-2 text-616161 form-label">
                  Status
                </Form.Label>
                <Form.Select
                  name="isCreditActive"
                  value={editFormData.isCreditActive}
                  onChange={handleEditFormChange}
                  className="rounded-pill"
                >
                  <option value={true}>Active</option>
                  <option value={false}>Inactive</option>
                </Form.Select>
              </Form.Group>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 p-3">
          <div className="d-flex gap-3 w-75">
            <Button
              variant="secondary"
              className="flex-grow-1 br-radius-8"
              onClick={() => setShowEditModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="success"
              className="flex-grow-1 br-radius-8"
              onClick={saveEditChanges}
            >
              Save Changes
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showUpdateCreditModal}
        onHide={() => setShowUpdateCreditModal(false)}
        centered
        size="md"
      >
        <Modal.Header closeButton className="border-0 bg-white">
          <Modal.Title className="w-100 text-center text-101828 mb-1 fw-600 ls-minus-0 fs-14">
            Update Credits
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 pt-0">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="fs-12 form-label ls-spacing-2 text-616161 form-label">
                Transaction Type
              </Form.Label>
              <Form.Select
                value={updateCreditData.transactionType}
                onChange={(e) =>
                  setUpdateCreditData({
                    ...updateCreditData,
                    transactionType: e.target.value,
                  })
                }
                className="rounded-pill"
              >
                <option value="CREDIT">CREDIT</option>
                <option value="DEBIT">DEBIT</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fs-12 form-label ls-spacing-2 text-616161 form-label">
                Credit Type
              </Form.Label>
              <Form.Select
                value={updateCreditData.creditType}
                onChange={(e) =>
                  setUpdateCreditData({
                    ...updateCreditData,
                    creditType: e.target.value,
                  })
                }
                className="rounded-pill"
              >
                <option value="SHORTENING">SHORTENING</option>
                <option value="TRACKING">TRACKING</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fs-12 form-label ls-spacing-2 text-616161 form-label">
                New Credit Amount
              </Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter credit amount"
                value={updateCreditData.newCredit}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || /^\d+$/.test(value)) {
                    setUpdateCreditData({
                      ...updateCreditData,
                      newCredit: value,
                    });
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === ".") {
                    e.preventDefault();
                  }
                }}
                min="0"
                step="1"
                className="rounded-pill"
                style={{ color: "#000" }}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fs-12 form-label ls-spacing-2 text-616161 form-label">
                Status
              </Form.Label>
              <Form.Select
                value={updateCreditData.active}
                onChange={(e) =>
                  setUpdateCreditData({
                    ...updateCreditData,
                    active: e.target.value === "true",
                  })
                }
                className="rounded-pill"
              >
                <option value={true}>Active</option>
                <option value={false}>Inactive</option>
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 p-3">
          <div className="d-flex gap-3 w-75">
            <Button
              variant="danger"
              className="flex-grow-1 br-radius-8"
              onClick={() => setShowUpdateCreditModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="success"
              className="flex-grow-1 br-radius-8"
              onClick={handleUpdateCredit}
              disabled={!updateCreditData.newCredit}
            >
              Update Credits
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showCreditRequestModal}
        onHide={() => setShowCreditRequestModal(false)}
        centered
        size="md"
      >
        <Modal.Header closeButton className="border-0 bg-white">
          <Modal.Title className="w-100 text-center text-101828 mb-1 fw-600 ls-minus-0 fs-14">
            Create Credit Request
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 pt-0">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="fs-12 form-label ls-spacing-2 text-616161">
                Requested Credits
              </Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter requested credit amount"
                value={creditRequestData.requestedCredits}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only numbers and max 5 digits
                  if (value === "" || (/^\d+$/.test(value) && value.length <= 5)) {
                    setCreditRequestData({
                      ...creditRequestData,
                      requestedCredits: value,
                    });
                    if (creditRequestErrors.requestedCredits) {
                      setCreditRequestErrors(prev => ({ ...prev, requestedCredits: "" }));
                    }
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === ".") {
                    e.preventDefault();
                  }
                }}
                min="0"
                max="99999"
                step="1"
                className="br-radius-8"
                isInvalid={!!creditRequestErrors.requestedCredits}
                style={{ color: "#000" }}
              />
              {creditRequestErrors.requestedCredits ? (
                <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
                  {creditRequestErrors.requestedCredits}
                </div>
              ) : (
                <Form.Text className="text-muted">
                  Maximum 5 digits (99999)
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fs-12 form-label ls-spacing-2 text-616161">
                Credit Type
              </Form.Label>
              <Form.Select
                value={creditRequestData.creditType}
                onChange={(e) =>
                  setCreditRequestData({
                    ...creditRequestData,
                    creditType: e.target.value,
                  })
                }
                className="br-radius-8"
                style={{ color: "#000" }}
              >
                <option value="SHORTENING">SHORTENING</option>
                <option value="TRACKING">TRACKING</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fs-12 form-label ls-spacing-2 text-616161">
                Remarks
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter remarks (max 100 words)"
                value={creditRequestData.remarks}
                onChange={(e) => {
                  const value = e.target.value;
                  const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
                  // Allow max 100 words or empty string
                  if (value === "" || wordCount <= 100) {
                    setCreditRequestData({
                      ...creditRequestData,
                      remarks: value,
                    });
                    if (creditRequestErrors.remarks) {
                      setCreditRequestErrors(prev => ({ ...prev, remarks: "" }));
                    }
                  }
                }}
                className="rounded"
                isInvalid={!!creditRequestErrors.remarks}
                style={{ color: "#000" }}
              />
              {creditRequestErrors.remarks ? (
                <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
                  {creditRequestErrors.remarks}
                </div>
              ) : (
                <div className="d-flex justify-content-end mt-1">
                  <small className="text-muted" style={{ fontSize: "10px" }}>
                    {creditRequestData.remarks.trim().split(/\s+/).filter(word => word.length > 0).length}/100 words
                  </small>
                </div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 p-3">
          <div className="d-flex gap-3 w-75">
            <Button
              variant="danger"
              className="flex-grow-1 br-radius-8"
              onClick={() => setShowCreditRequestModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="success"
              className="flex-grow-1 br-radius-8"
              onClick={handleCreditRequest}
            >
              Submit Request
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showSettingsModal}
        onHide={() => setShowSettingsModal(false)}
        centered
        size="md"
      >
        <Modal.Header closeButton className="border-0 bg-white">
          <Modal.Title className="w-100 text-center text-101828 mb-1 fw-600 ls-minus-0 fs-14">
            Account Status
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 pt-0">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="fs-12 form-label ls-spacing-2 text-616161 form-label">
                Status
              </Form.Label>
              <Form.Select
                value={settingsForm.isActive}
                onChange={(e) =>
                  setSettingsForm({
                    ...settingsForm,
                    isActive: e.target.value === "true"
                  })
                }
                className="rounded-pill"
              >
                <option value={true}>Enable</option>
                <option value={false}>Disable</option>
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 p-3">
          <div className="d-flex gap-3 w-75">
            <Button
              variant="danger"
              className="flex-grow-1 br-radius-8"
              onClick={() => setShowSettingsModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="success"
              className="flex-grow-1 br-radius-8"
              onClick={() => {
                handleStatusChange(settingsForm.accountId, settingsForm.isActive);
                setShowSettingsModal(false);
              }}
            >
              Save Changes
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};
export default CreditDashboard;
